import { Directive, forwardRef, HostAttributeToken, inject } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[validateEqual][formControllName],[validateEqual][formControl],[validateEqual][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EqualValidator),
            multi: true
        }
    ]
})
export class EqualValidator implements Validator {
  validateEqual = inject(new HostAttributeToken('validateEqual'), { optional: true });
  reverse = inject(new HostAttributeToken('reverse'), { optional: true });


  private get isReverse() {
    if (!this.reverse) return false;
    return this.reverse === 'true' ? true : false;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    if (!this.validateEqual) return null;
    const v = c.value;
    const e = c.root.get(this.validateEqual);

    // value not equal
    if (e && v !== e.value && !this.isReverse) {
      return {
        validateEqual: true
      };
    }

    // value equal and reverse
    if (e && v === e.value && this.isReverse) {
      delete e.errors!['validateEqual'];
      if (!Object.keys(e.errors!).length) e.setErrors(null);
    }

    // value not equal and reverse
    if (e && v !== e.value && this.isReverse) {
      e.setErrors({
        validateEqual: true
      });
    }
    return null;
  }

}
